/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useLogin } from '../../utilities/login';

export default function PrivateRoute({ component: Component, ...rest }) {
  const login = useLogin();
  return (
    <Route
      {...rest}
      render={props => {
        if (login) {
          return <Component {...props} />;
        }
        return (
          <Redirect
            to={{
              pathname: '/login',
              state: {
                from: props.location
              }
            }}
          />
        );
      }}
    />
  );
}
